import ArrowLeftIcon from "../../../../../../../assets/icons/ArrowLeftIcon"
import styles from "./index.module.scss"
import ArrowRightIcon from "../../../../../../../assets/icons/ArrowRightIcon"
import RcmpLoading from "../../../../../../atoms/Loading"
import Chart from "./chart"
import { useChartLevereyJenning } from "./useChartLevereyJenning"

export const ChartLereyJennings = ({
  anlt_nid,
  runs,
  setSelectedRun,
  pagination = true,
  setIsOpen,
  className,
}) => {
  const {
    chartData,
    runsWestardStatus,
    nSpaceBetweenVerticalLines,
    bLineAnimationActive,
    handleOnClickChart,
    handleClickMoveGraph,
    oFetchRunRes,
    bCanMore,
    hasMoreData,
    chartWrapperRef,
    selectedChartRun,
  } = useChartLevereyJenning({
    aRuns: runs,
    anlt_nid,
    pagination,
    setSelectedRun,
    setIsOpen,
  })

  return (
    <div
      ref={chartWrapperRef}
      className={`${styles.wrapperGraph} ${className ? className : ""}`}
    >
      {pagination && (
        <div className={styles.prevArrow}>
          {!oFetchRunRes.loading && (
            <ArrowLeftIcon
              className={styles.arrowIcon}
              onClick={() => handleClickMoveGraph("less")}
              disabled={!hasMoreData}
            />
          )}
          <RcmpLoading bShow={oFetchRunRes.loading} size={30} />
        </div>
      )}
      <Chart
        runs={runs}
        chartData={chartData}
        selectedChartRun={selectedChartRun}
        nSpaceBetweenVerticalLines={nSpaceBetweenVerticalLines}
        handleOnClickChart={handleOnClickChart}
        runsWestardStatus={runsWestardStatus}
        bLineAnimationActive={bLineAnimationActive}
      />
      {pagination && (
        <div className={styles.prevArrow}>
          <ArrowRightIcon
            className={styles.arrowIcon}
            onClick={() => handleClickMoveGraph("more")}
            disabled={!bCanMore}
          />
        </div>
      )}
    </div>
  )
}
